import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useDidMountEffect from 'assets/js/useDidMountEffect';
import * as ExcelJS from 'exceljs';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

/* DatePicker */
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';

/* MODAL */
import { useModal } from 'hooks/modalContext';

const Commute = () => {
  const { openModal } = useModal();

  const today = moment();
  const monday = today.startOf('isoWeek');
  const mondayDate = monday.format('YYYY-MM-DD');

  const [commuteMstPeriodList, setCommuteMstPeriodList] = useState({
    totalList: [{
      totalWorkTime: 0,
      totalRealWorkTime: 0,
      workCount: 0,
      realWorkCount: 0,
      absenceCount: 0,
      lateCount: 0,
      leaveCount: 0,
    }],
    periodList: [{
      commuteMstPeriodDetailDTOList: []
    }],
    dateList: []
  });
  const [custMstList, setCustMstList] = useState([{
    custMstSeq: 0,
    custName: '',
  }]);
  const [search, setSearch] = useState({
    fkCustMstSeq: 0,
    startDate: mondayDate,
    endDate: moment().format('YYYY-MM-DD'),
  });
  const [isSearch, setIsSearch] = useState(false);

  useEffect(() => {
    Common.isLogin();

    getCustMstList();
  }, []);

  useDidMountEffect(() => {
    if (isSearch) {
      getCommuteMstPeriodList();
    }
  }, [isSearch]);

  const getCustMstList = () => {
    Server.sendGet('client/select/all', {}, getCustMstListCallback).then();
  };

  const getCustMstListCallback = res => {
    setSearch(() => {
      return {
        ...search,
        fkCustMstSeq: res?.['resultList']?.[0]?.custMstSeq,
      }
    });
    setCustMstList(res?.['resultList']);
    setIsSearch(true);
  };

  const getCommuteMstPeriodList = () => {
    Server.sendGet('workforce/commute/period', {
      custMstSeq: search?.fkCustMstSeq,
      startDate: search?.startDate,
      endDate: search?.endDate,
    }, getCommuteMstPeriodListCallback).then();
  };

  const getCommuteMstPeriodListCallback = res => {
    setCommuteMstPeriodList(res['resultObject']);
  };

  const getModalData = (modalName, item) => ({
    modalName: modalName,
    modalData: {
      isRegi: false,
      data: {
        item: item,
        callback: getCommuteMstPeriodList,
      },
    },
  });

  const handleStartDateChange = date => handleDateChange(date, true);
  const handleEndDateChange = date => handleDateChange(date, false);

  const formatDate = date => moment(date['$d']).format('YYYY-MM-DD');

  const handleDateChange = (date, isStart) => {
    const formattedDate = formatDate(date);

    setSearch(search => {
      if (isStart) {
        const isBeforeDate = moment(search.endDate).isBefore(formattedDate);

        return {
          ...search,
          startDate: formattedDate,
          endDate: isBeforeDate ? formattedDate : search.endDate,
        };
      } else {
        const isBeforeDate = moment(formattedDate).isBefore(search.startDate);

        return {
          ...search,
          startDate: isBeforeDate ? formattedDate : search.startDate,
          endDate: formattedDate,
        };
      }
    });
  };

  const firstColNameList = ['Name', 'Working hours (minute)', 'Actual working hours (minute)', 'Number of work', 'Actual number of work','Number of absences','Number of lateness', 'Number of early leave'];

  //Excel Export
  async function exportExcel() {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('account');

    let currentChar = 65;

    for (let i = 0; i < firstColNameList.length; i++) {
      let currentCol = String.fromCharCode(currentChar) + '1';
      let idx = 3;

      let nextCol = '';

      switch (i) {
        case 0:
          nextCol = String.fromCharCode(currentChar + 1) + '2';
          idx = 2;
          sheet.mergeCells(currentCol + ':' + nextCol);

          Common.excelHeaderSet({
            currentCol: currentCol,
            title: firstColNameList[i],
            sheet: sheet,
          });
          break;

        default:
          nextCol = String.fromCharCode(currentChar + 2) + '2';
          sheet.mergeCells(currentCol + ':' + nextCol);

          Common.excelHeaderSet({
            currentCol: currentCol,
            title: firstColNameList[i],
            sheet: sheet,
          });

          break;
      }

      currentChar += idx;
    }

    //인력별 이력
    currentChar = 65;
    let currentRow = 3;

    //key arr
    const itemKeyArr = [
      'workerName',
      'totalWorkTime',
      'totalRealWorkTime',
      'workCount',
      'realWorkCount',
      'absenceCount',
      'lateCount',
      'leaveCount',
    ];

    for (let i = 0; i < commuteMstPeriodList?.totalList?.length; i++) {

      const item = commuteMstPeriodList?.totalList[i];

      for(let j = 0; j < itemKeyArr.length; j++) {

        let currentCol = String.fromCharCode(currentChar) + currentRow;
        let idx = 3;
        let nextCol = '';

        switch (j) {
          case 0:
            nextCol = String.fromCharCode(currentChar + 1) + currentRow;
            idx = 2;
            sheet.mergeCells(currentCol + ':' + nextCol);

            sheet.getCell(currentCol).value = item[itemKeyArr[j]];
            sheet.getCell(currentCol).alignment = {
              horizontal: 'center',
              vertical: 'middle'
            }

            break;
          case 2:
            nextCol = String.fromCharCode(currentChar + 2) + currentRow;
            idx = 3;
            sheet.mergeCells(currentCol + ':' + nextCol);

            sheet.getCell(currentCol).value = item.totalRealWorkTime > item.totalWorkTime ? item.totalWorkTime : item.totalRealWorkTime;
            sheet.getCell(currentCol).alignment = {
              horizontal: 'center',
              vertical: 'middle'
            }

            break;
          case 3:
            nextCol = String.fromCharCode(currentChar + 2) + currentRow;
            idx = 3;
            sheet.mergeCells(currentCol + ':' + nextCol);

            sheet.getCell(currentCol).value = item.totalRealWorkTime > item.totalWorkTime ? item.totalRealWorkTime - item.totalWorkTime : 0;
            sheet.getCell(currentCol).alignment = {
              horizontal: 'center',
              vertical: 'middle'
            }

            break;

          default:

            nextCol = String.fromCharCode(currentChar + 2) + currentRow;
            sheet.mergeCells(currentCol + ':' + nextCol);

            sheet.getCell(currentCol).value = item[itemKeyArr[j]];
            sheet.getCell(currentCol).alignment = {
              horizontal: 'center',
              vertical: 'middle'
            }

            idx = 3;

            break;
        }
        currentChar += idx;
      }

      currentRow++;
      currentChar = 65;
    }

    currentRow++;

    let currentCol = String.fromCharCode(currentChar) + currentRow;
    let nextCol = String.fromCharCode(currentChar + 1) + (currentRow + 1);

    sheet.mergeCells(currentCol + ':' + nextCol);

    Common.excelHeaderSet({
      currentCol: currentCol,
      title: 'Name',
      sheet: sheet,
    });

    currentChar += 2;

    for(let i = 0; i < commuteMstPeriodList?.dateList.length; i++) {

      const dateList = commuteMstPeriodList?.dateList;

      currentCol = String.fromCharCode(currentChar) + currentRow;
      nextCol = String.fromCharCode(currentChar + 3) + currentRow;

      sheet.mergeCells(currentCol + ':' + nextCol);

      Common.excelHeaderSet({
        currentCol: currentCol,
        title: dateList[i],
        sheet: sheet,
      });

      currentCol = String.fromCharCode(currentChar) + (currentRow + 1);
      nextCol = String.fromCharCode(currentChar + 1) + (currentRow + 1);

      sheet.mergeCells(currentCol + ':' + nextCol);

      sheet.getCell(currentCol).value = 'Go to work';
      sheet.getCell(currentCol).alignment = {
        horizontal: 'center',
        vertical: 'middle'
      }

      currentCol = String.fromCharCode(currentChar + 2) + (currentRow + 1);
      nextCol = String.fromCharCode(currentChar + 3) + (currentRow + 1);

      sheet.mergeCells(currentCol + ':' + nextCol);

      sheet.getCell(currentCol).value = 'Get off work';
      sheet.getCell(currentCol).alignment = {
        horizontal: 'center',
        vertical: 'middle'
      }

      currentChar += 4;
    }

    //다운로드 날짜
    await Common.download({
      workbook: workbook,
      fileName: 'test',
    });
  }

  return (
    <>
      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Commute management (per period)</h4>
          </TitHead>
        </Title>
        <DateSearch>
          <CateIn>
            <Cate>
              <CateSel
                name='workForm'
                id='workForm'
                value={search?.fkCustMstSeq}
                onChange={e => {
                  setSearch(() => {
                    return {
                      ...search,
                      fkCustMstSeq: e.target.value,
                    };
                  });
                }}
              >
                {custMstList?.map(item => (
                  <option key={item.custMstSeq} value={item.custMstSeq}>{item.custName}</option>
                ))}
              </CateSel>
            </Cate>
          </CateIn>
          <DateIn>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker', 'DatePicker']}>
                <DatePicker
                  onChangeRaw={e => e.preventDefault()}
                  format={'YYYY-MM-DD'}
                  value={dayjs(search?.startDate) || ''}
                  onChange={date => handleStartDateChange(date)}
                />
              </DemoContainer>
            </LocalizationProvider>
            <i/>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker', 'DatePicker']}>
                <DatePicker
                  onChangeRaw={e => e.preventDefault()}
                  format={'YYYY-MM-DD'}
                  value={dayjs(search?.endDate) || ''}
                  onChange={date => handleEndDateChange(date)}
                />
              </DemoContainer>
            </LocalizationProvider>
          </DateIn>
          <SearchBtn onClick={getCommuteMstPeriodList}>Search</SearchBtn>
          <SearchBtn onClick={exportExcel}>Excel export</SearchBtn>
        </DateSearch>
        <Content>
          <TableIn>
            <Table>
              <colgroup>
                <col width='10%'/>
                <col width='14%'/>
                <col width='13%'/>
                <col width='13%'/>
                <col width='10%'/>
                <col width='10%'/>
                <col width='10%'/>
                <col width='10%'/>
                <col width='10%'/>
              </colgroup>
              <thead>
              <tr>
                <th>Name</th>
                <th>Working hours (minutes)</th>
                <th>Actual working hours (minutes)</th>
                <th>Additional working hours (minutes)</th>
                <th>Number of work</th>
                <th>Actual number of work</th>
                <th>Number of absences</th>
                <th>Number of lateness</th>
                <th>Number of early leave</th>
              </tr>
              </thead>
              <tbody>
              {commuteMstPeriodList?.totalList?.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.workerName}</td>
                  <td>{item.totalWorkTime}</td>
                  <td>{item.totalRealWorkTime > item.totalWorkTime ? item.totalWorkTime : item.totalRealWorkTime}</td>
                  <td>{item.totalRealWorkTime > item.totalWorkTime ? item.totalRealWorkTime - item.totalWorkTime : 0}</td>
                  <td>{item.workCount}</td>
                  <td>{item.realWorkCount}</td>
                  <td>{item.absenceCount}</td>
                  <td>{item.lateCount}</td>
                  <td>{item.leaveCount}</td>
                </tr>
              ))}
              {Common.isEmpty(commuteMstPeriodList?.totalList) &&
                <tr>
                  <td colSpan={8} className={'none-data'}>
                    There is no data to output.
                  </td>
                </tr>
              }
              </tbody>
            </Table>
          </TableIn>
          <TableIn>
            <Table>
              <thead>
              <tr>
                <th rowSpan={2}>Name</th>
                {commuteMstPeriodList?.dateList?.map((item, idx) => (
                  <th colSpan={2} key={idx}>{item}</th>
                ))}
              </tr>
              <tr>
                {commuteMstPeriodList?.dateList?.map((item, idx) => (
                  <React.Fragment key={idx}>
                    <th>Go to work</th>
                    <th>Get off work</th>
                  </React.Fragment>
                ))}
              </tr>
              </thead>
              <tbody>
              {commuteMstPeriodList?.periodList?.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.workerName}</td>
                  {item.commuteMstPeriodDetailDTOList?.map((detail, detailIdx) => (
                    <React.Fragment key={detailIdx}>
                      <td
                        style={{ background: detail.attendanceState === 'N' || detail.attendanceState === 'A' ? '#ffb1b1' : 'transparent' }}
                        colSpan={detail.attendanceState === 'A' || detail.attendanceState === 'B' || detail.attendanceState === 'C' ? 2 : 1}
                        onClick={() => {
                          if (detail.attendanceState === 'N' || detail.attendanceState === 'A') {
                            openModal(getModalData('WorkforceCheckInModal', detail));
                          }
                        }}
                      >
                        {detail.inTime}
                      </td>
                      {detail.attendanceState !== 'A' && detail.attendanceState !== 'B' && detail.attendanceState !== 'C' &&
                        <td
                          style={{ background: detail.getOffState === 'N' || detail.attendanceState === 'A' ? '#ffb1b1' : 'transparent' }}
                          onClick={() => {
                            if (detail.getOffState === 'N' || detail.attendanceState === 'A') {
                              openModal(getModalData('WorkforceCheckOutModal', detail));
                            }
                          }}
                        >
                          {detail.outTime}
                        </td>
                      }
                    </React.Fragment>
                  ))}
                </tr>
              ))}
              {Common.isEmpty(commuteMstPeriodList?.periodList) &&
                <tr>
                  <td colSpan={(commuteMstPeriodList?.dateList?.length * 2) + 1} className={'none-time-data'}>
                    There is no data to output.
                  </td>
                </tr>
              }
              </tbody>
            </Table>
          </TableIn>
        </Content>
      </Inner>
    </>
  );
}

const Inner = styled.div`
  flex: 1;
  background: #ffffff;
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
`;

const DateSearch = styled.div`
  position: relative;
  margin-top: 35px;
  padding: 15px 20px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  gap: 0 15px;
  width: 100%;

  & .react-datepicker__tab-loop {
    position: absolute;
  }
`;

const DateIn = styled.div`
  display: flex;
  align-items: center;
  gap: 0 15px;

  .MuiStack-root {
    padding: 0;

    .MuiInputBase-root {
      background: #f8f8f8;
    }
  }

  & input {
    width: 116px;
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    font-weight: 400;
    font-size: 16px;
    color: #777777;
    border-radius: 5px;
    outline: none;
  }

  & i {
    display: block;
    width: 12px;
    height: 1px;
    background: rgba(0, 0, 0, 0.12);
  }

  & .react-datepicker-popper {
    width: 226px;
    z-index: 99;
  }
`;

const CateIn = styled.div`
  display: flex;
  align-items: center;
  gap: 0 20px;
`;

const Cate = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & label {
    font-weight: 400;
    font-size: 16px;
    color: #777777;
  }
`;

const CateSel = styled.select`
  width: 200px;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  font-weight: 400;
  font-size: 16px;
  color: #777777;
  background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  outline: none;
`;

const SearchBtn = styled.button`
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: #a4a4a4;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;

  &:hover {
    background-color: #7e7e7e;
  }
`;

const Content = styled.div`
  margin-top: 35px;
  position: relative;
  height: 622px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  & div:first-child {
    border-bottom: 1px solid #eeeeee;
    height: calc(40% - 17.5px) !important;
  }

  & div:not(:first-child) {
    margin-top: 35px;
  }
`;

const TableIn = styled.div`
  position: relative;
  max-width: 1543px;
  max-height: 600px;
  overflow-x: auto;
  height: calc(60% - 17.5px);
`;

const Table = styled.table`
  position: relative;

  & thead {
    position: sticky;
    top: 0;
  }

  & tr:first-child th:first-child, tr td:first-child {
    position: sticky;
    left: 0;
  }

  & thead {
    position: sticky;
    top: 0;
  }

  & th {
    padding: 6px 0;
    font-weight: 400;
    font-size: 18px;
    color: #777777;
    background: #f8f8f8;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
    vertical-align: middle;
  }

  & td {
    padding: 10px 0;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: center;
    vertical-align: middle;
    border-bottom: 1px solid #eeeeee;
    border-left: 1px solid #eeeeee;
    height: 61px;
  }

  & tfoot td {
    background: rgba(227, 240, 250, 255);
    font-size: 14px;
    font-weight: 600;
    color: #000000;
  }

  & thead > tr + tr > th {
    background-color: #fcfcfc;
    border-left: 1px solid #eeeeee;
    min-width: 90px;

    &:first-child {
      border-left: none;
    }
  }

  & tr td:first-child {
    border-left: none;
    min-width: 100px;
  }

  & tr td {
    min-width: 90px;
  }

  & tbody tr:nth-child(odd) td {
    background: #ffffff;
  }

  & tbody tr:nth-child(even) td {
    background: #fcfcfc;
  }

  & tr td.none-data {
    height: 130px;
    border: 0;
  }

  & tr td.none-time-data {
    height: 294px;
    border: 0;
  }
`;

export default Commute;
